import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M16.839 17H7.161c-1.677 0-2.609-1.94-1.561-3.25l1.397-1.746.003-.01V9a5 5 0 0 1 10 0v2.994q0 .006.004.01l1.397 1.747c1.047 1.31.115 3.249-1.562 3.249M10 18h4a2 2 0 1 1-4 0"
    }
  )
);
var SvgNotificationOnFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var NotificationOnFilled_default = SvgNotificationOnFilled;

export { NotificationOnFilled_default as default };
